import { TOOLBOX_SEARCH_PARAM } from "./AppToolboxSlot.constants";

export const toolboxSectionParam = (
  section: string
): Partial<Record<typeof TOOLBOX_SEARCH_PARAM, string>> =>
  section ? { [TOOLBOX_SEARCH_PARAM]: section } : {};

export const assignToolboxSection = <
  T extends URLSearchParams | Record<string, string>,
>(
  target: T,
  section: string
): T => {
  if (!section) return target;

  if (target instanceof URLSearchParams) {
    target.set(TOOLBOX_SEARCH_PARAM, section);
  } else {
    (target as Record<string, string>)[TOOLBOX_SEARCH_PARAM] = section;
  }

  return target;
};
